import Phaser from 'phaser';
import { CONFIG } from '../config.js';

export class WaveSystem {
  constructor(scene) {
    this.scene = scene;
    this.currentWaveIndex = -1;
    this.waveStartedAt = 0;
    this.killsThisWave = 0;
    this.lastSpawnAt = 0;
    this.bossSpawned = false;
    this.state = 'idle'; // idle | running | between | boss | done
    // GameScene fills these in before the first startWave call.
    this.waves = scene.levelWaves || CONFIG.LEVEL_WAVES.basic;
  }

  setWaves(waves) {
    this.waves = waves || CONFIG.LEVEL_WAVES.basic;
  }

  startWave(idx) {
    this.currentWaveIndex = idx;
    this.killsThisWave = 0;
    this.waveStartedAt = this.scene.time.now;
    this.lastSpawnAt = 0;
    this.state = 'running';
    const wave = this.waves[idx];
    this.scene.events.emit('wave-start', { waveId: wave.id, idx, wave });
  }

  startBoss() {
    if (this.bossSpawned) return;
    this.bossSpawned = true;
    this.state = 'boss';
    this.scene.events.emit('wave-boss-start');
    this.scene.spawnSystem.spawnBoss();
  }

  onEnemyKilled(enemy) {
    if (this.state === 'running' && !enemy.isMinion && !enemy.isBoss) {
      this.killsThisWave++;
      this.scene.events.emit('wave-progress', {
        kills: this.killsThisWave,
        target: this.currentWave().killTarget,
      });
    }
  }

  currentWave() {
    return this.waves[this.currentWaveIndex];
  }

  update(time, delta) {
    if (this.state !== 'running') return;
    const wave = this.currentWave();
    if (!wave) return;

    if (time - this.lastSpawnAt >= wave.spawnIntervalMs) {
      this.spawnFromWave(wave);
      this.lastSpawnAt = time;
    }

    const elapsed = time - this.waveStartedAt;
    if (elapsed >= wave.durationMs || this.killsThisWave >= wave.killTarget) {
      this.endCurrentWave();
    }
  }

  spawnFromWave(wave) {
    const type = Phaser.Utils.Array.GetRandom(wave.enemies);
    this.scene.spawnSystem.spawnEnemy(type, { speedMult: wave.speedMult });
    if (wave.multiSpawnChance && Math.random() < wave.multiSpawnChance) {
      const type2 = Phaser.Utils.Array.GetRandom(wave.enemies);
      this.scene.spawnSystem.spawnEnemy(type2, { speedMult: wave.speedMult });
    }
  }

  endCurrentWave() {
    this.state = 'between';
    const finishedIdx = this.currentWaveIndex;
    this.scene.events.emit('wave-end', { idx: finishedIdx });

    const next = finishedIdx + 1;
    if (next >= this.waves.length) {
      this.scene.time.delayedCall(2400, () => this.startBoss());
    } else {
      this.scene.time.delayedCall(2400, () => this.startWave(next));
    }
  }

  remainingTimeMs(time) {
    if (this.state !== 'running') return 0;
    const wave = this.currentWave();
    if (!wave) return 0;
    return Math.max(0, wave.durationMs - (time - this.waveStartedAt));
  }
}
